<template>
    <div v-if="userShipping" class="shipping-list">
        <h3 class="shipping-list-heading">
            Shipping
        </h3>
        <p class="shipping-list-subheading">Please note: Final prices may change when you select your shipping address.</p>
        <hr>
        <div class="shipping-item">
            <div class="shipping-item-content">
                <div class="shipping-item-image">
                    <img src="/images/icons/cart-icons/normal-shipping.svg" alt="">
                </div>
                <div class="shipping-item-text">
                    <h5 class="shipping-item-name">
                        {{ userShipping.title }}
                    </h5>
                    <p class="shipping-item-color">
                        {{ userShipping.description }}
                    </p>
                </div>
            </div>
            <div class="shipping-item-actions">
                <p class="shipping-item-price">{{ userShipping.amount | formatMoney }}</p>
            </div>
        </div>
        <!-- <hr>
        <div class="shipping-item">
            <div class="shipping-item-content">
                <div class="shipping-item-image">
                    <img src="/images/icons/cart-icons/normal-shipping.svg" alt="">
                </div>
                <div class="shipping-item-text">
                    <h5 class="shipping-item-name">
                        Ground Shipping
                    </h5>
                    <p class="shipping-item-color">
                        3-6 business days
                    </p>
                </div>
            </div>
            <div class="shipping-item-actions">
                <multiselect
                    :allow-empty="false"
                    :options="['FedEx 2-5 day Ground', 'FedEx 2 day Priority']"
                    :searchable="false"
                    :show-labels="false"
                    value="FedEx 2-5 day Ground"
                />
                <div class="shipping-item-blank" v-else/>
                <p class="shipping-item-price">{{ 50 | formatMoney }}</p>
            </div>
        </div> -->
        <template v-if="totalMonitors && userShipping.amount_extra.monitor">
            <hr>
            <div class="shipping-item">
                <div class="shipping-item-content">
                    <div class="shipping-item-image">
                        <img src="/images/icons/cart-icons/normal-shipping.svg" alt="">
                    </div>
                    <div class="shipping-item-text">
                        <h5 class="shipping-item-name">
                            Monitor Shipping
                        </h5>
                    </div>
                </div>
                <div class="shipping-item-actions">
                    <p class="shipping-item-price">{{ userShipping.amount_extra.monitor * totalMonitors | formatMoney }}</p>
                </div>
            </div>
        </template>
        <!-- <hr>
        <div class="shipping-item">
            <div class="shipping-item-content">
                <div class="shipping-item-image">
                    <img src="/images/icons/cart-icons/document.svg" alt="">
                </div>
                <div class="shipping-item-text">
                    <h5 class="shipping-item-name">
                        California eWaste Recycling Fee
                    </h5>
                    <p class="shipping-item-color">
                        A $6 recycling fee is added to every monitor purchased that is being shipped to California
                    </p>
                </div>
            </div>
            <div class="shipping-item-actions">
                <p class="shipping-item-price">{{ 6 | formatMoney }}</p>
            </div>
        </div> -->
        <!-- <hr>
        <div class="shipping-item">
            <div class="shipping-item-content">
                <div class="shipping-item-image">
                    <img src="/images/icons/cart-icons/document.svg" alt="">
                </div>
                <div class="shipping-item-text">
                    <h5 class="shipping-item-name">
                        Estimated State Tax
                    </h5>
                </div>
            </div>
            <div class="shipping-item-actions">
                <p class="shipping-item-price">{{ 120.03 | formatMoney }}</p>
            </div>
        </div> -->
        <hr>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    name: "ShippingTaxes",
    computed: {
        ...mapGetters({
            userShipping: "userShipping",
            totalMonitors: "StarterPc/totalMonitors"
        }),
        ...mapState({
            cart: state => state.StarterPc.cart,
            shippingRates: state => state.Application.shippingRates,
            userLocation: state => state.User.location
        })
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.shipping-list {
    &-heading {
        color: $black;
        margin: 33px 0 0 25px;

        @media (min-width: 320px) and (max-width: 580px) {
            margin: 33px 0 33px 0;
        }
    }

    &-subheading {
        margin: 5px 0 31px 25px;
    }
}

hr {
    border-top: 1px solid #dadde0;
    margin: 0;
}

.shipping-item {
    padding: 0 42px 0 41px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @media (min-width: 320px) and (max-width: 580px) {
        padding: 23px 0 16px 10px;
        flex-direction: column;
    }

    &-content {
        display: flex;
    }

    &-image {
        align-items: center;
        display: flex;
        height: 96px;
        justify-content: center;
        margin-right: 18px;
        width: 96px;

        @media (min-width: 320px) and (max-width: 580px) {
            flex-shrink: 0;
        }

        img {
            max-height: 48px;
            max-width: 48px;
        }
    }

    &-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    &-name,
    &-price {
        color: #141226;
        font-weight: bold;
    }

    &-name {
        margin-bottom: 4px;
        font-size: 16px;

        @media (min-width: 320px) and (max-width: 580px) {
            margin-top: 0;
        }
    }

    &-actions {
        align-items: center;
        display: flex;
        height: 96px;

        @media (min-width: 320px) and (max-width: 580px) {
            margin-left: 115px;
            margin-top: -25px;
        }
    }

    &-price {
        font-size: 16px;
        margin-bottom: 0;
        width: 60px;
    }
}
</style>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.shipping-item {
    .multiselect {
        height: 36px;
        margin-right: 80px;

        @media (min-width: 320px) and (max-width: 580px) {
            font-size: 14px;
        }

        &__select {
            @media (min-width: 320px) and (max-width: 580px) {
                height: 36px;
            }
        }

        &__option--highlight {
            background: $purple;
            outline: none;
            color: #fff;
        }
        &__option--selected {
            &.multiselect__option--highlight {
                background: #f3f3f3;
                color: #35495e;
                cursor: default;
            }
        }
    }
}
</style>
